
export default {
  head() {
    return {
      title: "Création site internet de plombier avec l’agence ALEO",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Vous voulez créer un site web pour mettre en avant vos services de plombier ? Contactez l’agence ALEO pour découvrir ses solutions digitales à prix accessible !",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Création site internet de plombier avec l’agence ALEO",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Vous voulez créer un site web pour mettre en avant vos services de plombier ? Contactez l’agence ALEO pour découvrir ses solutions digitales à prix accessible !",
        },
      ],
    };
  },
};
